/* Pharmesthetic salon list v3 — metaobject-driven (36-salon edition, new fields) */
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);} }
  function esc(x){ return String(x||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  function loadSalons(token){
    var out=[], cursor=null;
    var q='query($c:String){ metaobjects(type:"salon", first:250, after:$c){ nodes{ handle fields{ key value reference{ ... on MediaImage{ image{ url } } } } } pageInfo{ hasNextPage endCursor } } }';
    function page(){
      return fetch('/api/2025-01/graphql.json',{method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':token},body:JSON.stringify({query:q,variables:{c:cursor}})})
      .then(function(r){return r.json();})
      .then(function(j){
        if(!j.data||!j.data.metaobjects) throw new Error('storefront api error');
        var mo=j.data.metaobjects;
        mo.nodes.forEach(function(nd){
          var f={};
          nd.fields.forEach(function(x){ f[x.key]=x.value||''; if(x.reference&&x.reference.image){ var u=x.reference.image.url; f[x.key+'_url']=u+(u.indexOf('?')>=0?'&':'?')+'width=1200'; } });
          if(!f.name) return;
          out.push({
            n:f.name, owner:f.owner_name||'', a:f.address||'', station:f.station||'', t:f.tel||'',
            intro:f.salon_intro||'', badge:f.badge||'',
            links:{instagram:f.link_instagram,line:f.link_line,hpb:f.link_hpb,hp:f.link_hp,tiktok:f.link_tiktok,x:f.link_x,youtube:f.link_youtube},
            img:f.salon_image_url||'', pimg:f.person_image_url||'',
            lat:f.lat?parseFloat(f.lat):null, lng:f.lng?parseFloat(f.lng):null
          });
        });
        if(mo.pageInfo.hasNextPage){ cursor=mo.pageInfo.endCursor; return page(); }
        return out;
      });
    }
    return page();
  }

  ready(function(){
    var token=(window.SALON_SF_TOKEN||'').trim();
    var geoMsg=document.getElementById('pjGeoMessage');
    if(!token){ if(geoMsg) geoMsg.textContent='サロン情報を読み込めませんでした。'; return; }
    loadSalons(token).then(init).catch(function(){ if(geoMsg) geoMsg.textContent='サロン情報を読み込めませんでした。時間をおいて再度お試しください。'; });
  });

  function init(salons){
    salons.sort(function(a,b){ return a.n.localeCompare(b.n,'ja'); });
    var mapEl = document.getElementById('pjSalonMap');
    if(!mapEl || typeof L==='undefined') return;
    var map = L.map('pjSalonMap',{scrollWheelZoom:false}).setView([36.2048,137.9],5);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'&copy; OpenStreetMap contributors'}).addTo(map);
    var icon = L.icon({iconUrl:'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',iconRetinaUrl:'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',shadowUrl:'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',iconSize:[25,41],iconAnchor:[12,41],popupAnchor:[1,-34],shadowSize:[41,41]});

    function addMarker(s){
      if(s.lat===null||isNaN(s.lat)) return;
      var m=L.marker([s.lat,s.lng],{icon:icon}).addTo(map);
      m.on('click',function(){ openModal(s); saveRecent(s); });
      s._marker=m;
    }
    salons.forEach(addMarker);

    /* runtime geocode for entries missing coords (cached) */
    try{
      var cache=JSON.parse(localStorage.getItem('pj_geo_cache')||'{}');
      salons.filter(function(s){return (s.lat===null||isNaN(s.lat))&&/[都道府県市区町村]/.test(s.a);}).slice(0,20).forEach(function(s){
        var key=s.a;
        var q=s.a.replace(/〒\s*\d{3}[-‐−ー]?\d{4}/g,'').replace(/（[^）]*）/g,'').replace(/[　\s]+/g,'').trim();
        if(cache[key]){ s.lat=cache[key][0]; s.lng=cache[key][1]; addMarker(s); return; }
        fetch('https://msearch.gsi.go.jp/address-search/AddressSearch?q='+encodeURIComponent(q)).then(function(r){return r.json();}).then(function(a){
          if(Array.isArray(a)&&a.length&&a[0].geometry){ var c=a[0].geometry.coordinates; s.lat=c[1]; s.lng=c[0]; cache[key]=[s.lat,s.lng]; localStorage.setItem('pj_geo_cache',JSON.stringify(cache)); addMarker(s); }
        }).catch(function(){});
      });
    }catch(e){}

    /* ---- icons ---- */
    function icPin(){ return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>'; }
    function icTel(){ return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"/></svg>'; }
    function icLink(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="3" width="16" height="18" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>'; }
    function icInsta(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none"/></svg>'; }
    function icHpb(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M8 8v8M16 8v8M8 12h8"/></svg>'; }
    function icLine(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11c0 4-4 7-9 7-.7 0-1.4-.1-2-.2L6 20l.6-2.4C4.4 16.4 3 13.9 3 11c0-4 4-7 9-7s9 3 9 7z"/></svg>'; }
    function icTiktok(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 4v10.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 5c.5 2.5 2.5 4 5 4"/></svg>'; }
    function icX(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4l16 16M20 4L4 20"/></svg>'; }
    function icYt(){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="6" width="18" height="12" rx="3"/><path d="M10 9.5l5 2.5-5 2.5z" fill="currentColor" stroke="none"/></svg>'; }

    function linkButtons(s){
      var h='';
      if(s.links.instagram) h+='<a class="pj-modal-link" href="'+esc(s.links.instagram)+'" target="_blank" rel="noopener">'+icInsta()+'<span>Instagram</span></a>';
      if(s.links.line) h+='<a class="pj-modal-link" href="'+esc(s.links.line)+'" target="_blank" rel="noopener">'+icLine()+'<span>LINE</span></a>';
      if(s.links.hpb) h+='<a class="pj-modal-link" href="'+esc(s.links.hpb)+'" target="_blank" rel="noopener">'+icHpb()+'<span>ホットペッパービューティー</span></a>';
      if(s.links.hp) h+='<a class="pj-modal-link" href="'+esc(s.links.hp)+'" target="_blank" rel="noopener">'+icLink()+'<span>Salon Link</span></a>';
      if(s.links.tiktok) h+='<a class="pj-modal-link" href="'+esc(s.links.tiktok)+'" target="_blank" rel="noopener">'+icTiktok()+'<span>TikTok</span></a>';
      if(s.links.x) h+='<a class="pj-modal-link" href="'+esc(s.links.x)+'" target="_blank" rel="noopener">'+icX()+'<span>X</span></a>';
      if(s.links.youtube) h+='<a class="pj-modal-link" href="'+esc(s.links.youtube)+'" target="_blank" rel="noopener">'+icYt()+'<span>YouTube</span></a>';
      return h;
    }

    /* ---- detail modal ---- */
    var overlay=null;
    function ensureOverlay(){
      if(overlay) return overlay;
      overlay=document.createElement('div');
      overlay.className='pj-modal-overlay';
      overlay.innerHTML='<div class="pj-modal" role="dialog" aria-modal="true"><button type="button" class="pj-modal-close" aria-label="閉じる">×</button><div class="pj-modal-body"></div></div>';
      document.body.appendChild(overlay);
      overlay.addEventListener('click',function(e){ if(e.target===overlay) closeModal(); });
      overlay.querySelector('.pj-modal-close').addEventListener('click',closeModal);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeModal(); });
      return overlay;
    }
    function closeModal(){ if(overlay){ overlay.classList.remove('is-open'); document.body.style.overflow=''; } }
    function openModal(s){
      var o=ensureOverlay();
      var gmap='https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(s.a.replace(/（詳細非公開）/,''));
      var personImg = s.pimg ? '<img class="pj-real-img pj-real-img--person" src="'+esc(s.pimg)+'" alt="'+esc(s.owner||s.n)+'">' : '<div class="pj-mock-img pj-mock-img--person">本人画像</div>';
      var salonImg = s.img ? '<img class="pj-real-img pj-real-img--salon" src="'+esc(s.img)+'" alt="'+esc(s.n)+'">' : '<div class="pj-mock-img pj-mock-img--salon">サロン画像</div>';
      var links=linkButtons(s);
      var badge = s.badge ? '<span class="pj-badge'+(s.badge.indexOf('公式認定')<0?' pj-badge--plain':'')+'">'+esc(s.badge)+'</span>' : '';
      var h='';
      h+='<div class="pj-mv2-row">';
      h+='<div class="pj-mv2-imgcell">'+personImg+'</div>';
      h+='<div class="pj-modal-info">';
      h+='<p class="pj-modal-name">'+esc(s.n)+'</p>';
      h+=badge;
      h+='<div class="pj-modal-row">'+icPin()+'<div>'+esc(s.a)+(s.station?'<br><span class="pj-station">'+esc(s.station)+'</span>':'')+'<br><a class="pj-gmap" href="'+gmap+'" target="_blank" rel="noopener">Google Map</a></div></div>';
      if(s.t) h+='<div class="pj-modal-row">'+icTel()+'<div><a class="pj-tel" href="tel:'+esc(String(s.t).replace(/[^0-9+]/g,''))+'">'+esc(s.t)+'</a></div></div>';
      if(s.owner) h+='<div class="pj-mv2-owner"><span class="pj-mv2-owner-label">オーナー</span><span class="pj-mv2-owner-name">'+esc(s.owner)+'</span></div>';
      if(links) h+='<div class="pj-modal-row"><div class="pj-modal-links">'+links+'</div></div>';
      h+='</div></div>';
      h+='<div class="pj-mv2-row">';
      h+='<div class="pj-mv2-imgcell">'+salonImg+'</div>';
      h+='<div class="pj-mv2-salontext"><p class="pj-mv2-label">サロン紹介</p><p class="pj-mv2-body">'+esc(s.intro||'')+'</p></div>';
      h+='</div>';
      o.querySelector('.pj-modal-body').innerHTML=h;
      o.classList.add('is-open');
      document.body.style.overflow='hidden';
    }

    function card(s){
      var div=document.createElement('div');
      div.className='pj-salon-card';
      var photo=s.img||s.pimg;
      div.innerHTML=(photo?'<img class="pj-card-photo" loading="lazy" src="'+esc(photo)+'" alt="'+esc(s.n)+'">':'')
        +'<p class="pj-card-name">'+esc(s.n)+'</p>'
        +(s.badge?'<p class="pj-card-badge">'+esc(s.badge)+'</p>':'')
        +'<p class="pj-card-addr">'+esc(s.a)+'</p>'
        +(s.t?'<p class="pj-card-tel">TEL：'+esc(s.t)+'</p>':'');
      if(photo) div.classList.add('has-photo');
      div.addEventListener('click',function(e){ if(e.target.closest('a')) return; saveRecent(s); openModal(s); });
      return div;
    }

    /* --- geolocation --- */
    var geoMsg=document.getElementById('pjGeoMessage');
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition(function(pos){
        map.setView([pos.coords.latitude,pos.coords.longitude],11);
        L.circleMarker([pos.coords.latitude,pos.coords.longitude],{radius:8,color:'#1a73e8',fillColor:'#1a73e8',fillOpacity:.9}).addTo(map).bindPopup('現在地');
        geoMsg.textContent='現在地周辺のサロンを表示しています。地図上のピンをクリックすると詳細が表示されます。';
      },function(){
        geoMsg.textContent='現在地を取得できませんでした。登録されている全ての店舗を表示します。';
      },{timeout:8000});
    } else {
      geoMsg.textContent='現在地を取得できませんでした。登録されている全ての店舗を表示します。';
    }

    /* --- search --- */
    var RESULT_STEP=12, shown=0, current=[];
    var grid=document.getElementById('pjResultsGrid');
    var section=document.getElementById('pjResultsSection');
    var count=document.getElementById('pjResultCount');
    function renderMore(){
      current.slice(shown,shown+RESULT_STEP).forEach(function(s){ grid.appendChild(card(s)); });
      shown=Math.min(shown+RESULT_STEP,current.length);
      var old=document.querySelector('.pj-more-wrap'); if(old) old.remove();
      if(shown<current.length){
        var w=document.createElement('div'); w.className='pj-more-wrap';
        var b=document.createElement('button'); b.type='button'; b.className='pj-more-btn'; b.textContent='もっと見る（残り'+(current.length-shown)+'件）';
        b.addEventListener('click',renderMore); w.appendChild(b); section.appendChild(w);
      }
    }
    function runSearch(kw){
      kw=(kw||'').trim().toLowerCase();
      current=!kw?salons.slice():salons.filter(function(s){ return (s.n+' '+s.owner+' '+s.a+' '+s.station+' '+(s.t||'')).toLowerCase().indexOf(kw)>=0; });
      grid.innerHTML=''; shown=0; section.hidden=false;
      count.textContent='（'+current.length+'件）';
      renderMore();
      var pts=current.filter(function(s){return s.lat!==null&&!isNaN(s.lat);}).map(function(s){return [s.lat,s.lng];});
      if(pts.length){ map.fitBounds(pts,{padding:[40,40],maxZoom:14}); }
      section.scrollIntoView({behavior:'smooth',block:'start'});
    }
    document.getElementById('pjSalonSearchForm').addEventListener('submit',function(e){ e.preventDefault(); runSearch(document.getElementById('pjSalonKeyword').value); });

    /* show all salons initially */
    runSearch('');
    window.scrollTo(0,0);

    /* --- recently viewed --- */
    var LS_KEY='pj_salon_recent_v3';
    function getRecent(){ try{ return JSON.parse(localStorage.getItem(LS_KEY)||'[]'); }catch(e){ return []; } }
    function saveRecent(s){
      try{
        var list=getRecent().filter(function(x){ return x!==s.n; });
        list.unshift(s.n);
        localStorage.setItem(LS_KEY,JSON.stringify(list.slice(0,6)));
        renderRecent();
      }catch(e){}
    }
    function renderRecent(){
      var g=document.getElementById('pjRecentGrid');
      var list=getRecent(); if(!list.length) return;
      g.innerHTML='';
      list.forEach(function(nm){
        var full=salons.find(function(s){return s.n===nm;});
        if(full) g.appendChild(card(full));
      });
    }
    renderRecent();
  }
})();
